module.exports = __webpack_public_path__ + "static/media/ratingStars.416dada8.svg";